// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"LightingElecConsumption_cardBoxSty__jhv8K","charts_wrapper":"LightingElecConsumption_charts_wrapper__if2xd"};